module.exports = __webpack_public_path__ + "assets/img/b37c-dz.svg";